import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { InstallationDetailsStore, RemoteDiagnosticsUseCasesStore } from '@store';
import { UIService } from '@services';
import { Observable, Subject } from 'rxjs';
import { UseCaseGroup, UseCaseTypesEnum } from '@vi-iot/client';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-diagnostics-use-cases-modal',
  templateUrl: './diagnostics-use-cases-modal.component.html',
  styleUrls: ['./diagnostics-use-cases-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsUseCasesModalComponent implements OnInit, OnDestroy {
  gatewaySerial: string;
  selectedUseCaseGroup: string;
  selectedUseCaseType: UseCaseTypesEnum;
  useCaseGroups$: Observable<UseCaseGroup[]>;

  readonly useCaseTypesEnum = UseCaseTypesEnum;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DiagnosticsUseCasesModalComponent>,
    public installationDetailsStore: InstallationDetailsStore,
    public remoteDiagnosticsUseCasesStore: RemoteDiagnosticsUseCasesStore,
    private activatedRoute: ActivatedRoute,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams['gatewaySerial'];

    this.useCaseGroups$ = this.remoteDiagnosticsUseCasesStore.getUseCaseGroups(this.gatewaySerial);

    this.remoteDiagnosticsUseCasesStore
      .getSelectedUseCaseType(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((selectedUseCaseType) => {
        this.selectedUseCaseType = selectedUseCaseType;
      });

    this.remoteDiagnosticsUseCasesStore
      .getSelectedUseCaseGroup(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((selectedUseCaseGroup) => {
        this.selectedUseCaseGroup = selectedUseCaseGroup;
        if (
          this.selectedUseCaseGroup &&
          this.selectedUseCaseType === UseCaseTypesEnum.ServiceLayer
        ) {
          this.remoteDiagnosticsUseCasesStore.selectUseCaseVddList(this.gatewaySerial);
        }
      });
  }

  onSelectUseCaseType(useCaseType: UseCaseTypesEnum): void {
    if (!this.selectedUseCaseType) {
      this.remoteDiagnosticsUseCasesStore.changeUseCaseType(useCaseType, this.gatewaySerial);
    }
  }

  onUnselectUseCaseType(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.remoteDiagnosticsUseCasesStore.changeUseCaseType(null, this.gatewaySerial);
    this.uiService.isAnyParameterRunning$.next(false);
  }

  onSelectUseCaseGroup(useCaseGroup: string): void {
    if (!this.selectedUseCaseGroup) {
      this.remoteDiagnosticsUseCasesStore.changeUseCaseGroup(this.gatewaySerial, useCaseGroup);
      this.remoteDiagnosticsUseCasesStore.loadUseCaseVddList(this.gatewaySerial, useCaseGroup);
      this.dialogRef.close();
    }
  }

  onUnselectUseCaseGroup(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.remoteDiagnosticsUseCasesStore.changeUseCaseGroup(this.gatewaySerial, null);
    this.uiService.isAnyParameterRunning$.next(false);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
